import { Trans } from '@lingui/react'
import { shape } from 'prop-types'
import { compose } from 'redux'

import BannerCard from 'views/components/organisms/HeaderNew/BannerCard'
import SubmenuCard from 'views/components/organisms/HeaderNew/SubmenuCard'
import SubmenuCardTitle from 'views/components/organisms/HeaderNew/SubmenuCardTitle'
import withMountPoints from 'views/enhancers/withMountPoints'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { mountPointsType, publicRuntimeConfigType } from 'views/utils/propTypes'

const getBanner = mountPoints => ({
  title: 'Welche Rezeptarten gibt es? ',
  imageURL: 'https://static.shop-apotheke.com/media/content/80x80/rezept.png',
  text: 'Kassenrezept, Privatrezept oder elektronisch Rezept - hier erfahren Sie mehr!',
  link: mountPoints.getRedeemRecipeFunnel(),
  openInNewTab: true,
})

const RedeemRequestPrescription = ({
  mountPoints,
  publicRuntimeConfig: {
    publicConfig: { deviceClass },
  },
}) => {
  const { title, text, imageURL, link } = getBanner(mountPoints)

  return (
    <div className="u-background-color--greySky">
      <div className="u-visuallyhidden@small-tiny l-flex@medium l-flex--start@medium">
        <div className="l-col--4-of-12@medium">
          <SubmenuCardTitle>
            <Trans id="general.link.label.recipe" />
          </SubmenuCardTitle>
        </div>
        <div className="l-col--4-of-12@medium u-margin-large--left@medium">
          <SubmenuCardTitle>
            <Trans id="offcanvas.header.menu.inNeedOfPrescription" />
          </SubmenuCardTitle>
        </div>
        <div className="l-col--4-of-12@medium u-margin-large--left@medium">
          <SubmenuCardTitle visuallyHidden>
            <Trans id="offcanvas.header.menu.inNeedOfPrescription" />
          </SubmenuCardTitle>
        </div>
      </div>
      <div className="l-flex@medium l-flex--stretch-children@medium u-padding-large--bottom">
        <SubmenuCard
          cardClasses="l-col--4-of-12@medium"
          title={<Trans id="general.link.label.recipe" />}
        >
          <div>
            <Trans id="offcanvas.header.menu.orderForSameDayDelivery" />
          </div>
          <div className="u-margin-large--top">
            <a
              href={mountPoints.getRedeemRecipeFunnel()}
              className="a-Button"
              data-qa-id="redeemRequestLink"
            >
              <Trans id="general.link.label.recipe" />
            </a>
          </div>
        </SubmenuCard>

        <SubmenuCard
          cardClasses="l-col--4-of-12@medium u-margin-large--left@medium"
          title={<Trans id="offcanvas.header.menu.inNeedOfPrescription" />}
        >
          <div>
            <Trans id="offcanvas.header.menu.getPrescriptionAdviceFromDoctor" />
          </div>
          <div className="u-margin-large--top">
            <a
              href={mountPoints.getOnlineDoctorService()}
              className="a-Button a-Button--ghost"
              data-qa-id="onlineDoctorServiceLink"
            >
              <Trans id="buyBox.link.label.onlineDoctorService.zava" />
            </a>
          </div>
        </SubmenuCard>

        <div className="o-SubmenuItem l-col--4-of-12@medium u-margin-large--left@medium u-no-padding--right@medium u-no-padding--top@small-tiny u-margin-large--top@small-tiny u-padding-large@small-tiny l-flex--stretch-children@small-tiny">
          <BannerCard
            title={title}
            text={text}
            imageURL={imageURL}
            link={link}
            boxClasses="min-height@medium"
            deviceClass={deviceClass}
          />
        </div>
      </div>
    </div>
  )
}

RedeemRequestPrescription.propTypes = {
  mountPoints: mountPointsType.isRequired,
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
}

RedeemRequestPrescription.defaultProps = {}

export default compose(
  withMountPoints,
  withShopAndRuntimeConfig
)(RedeemRequestPrescription)
